import { useTranslation } from 'react-i18next';
import { ChatContextType, CharactersData, EntityActionCard, ScriptCharacter } from '@packages/global';
import EntityChatPanel from './EntityChatPanel';

export interface CharactersChatPanelProps {
  projectId: string;
  episodeScriptId: string;
  currentData?: CharactersData | null;
  onApply?: (action: { type: 'create' | 'update' | 'delete'; character?: ScriptCharacter; index?: number }) => void | Promise<void>;
}

export default function CharactersChatPanel({ projectId, episodeScriptId, currentData, onApply }: CharactersChatPanelProps) {
  const { t } = useTranslation('script');
  const handleApplyAction = async (action: EntityActionCard) => {
    if (!onApply) return;

    if (action.actionType === 'create') {
      await onApply({
        type: 'create',
        character: { name: action.name, prompt: action.prompt || '', imageUrl: action.imageUrl }
      });
    } else if (action.actionType === 'update') {
      // 主数据源是 ProjectAsset，不依赖 currentData 的 index 查找
      await onApply({
        type: 'update',
        // LLM 修改了提示词，旧图片已不匹配，强制清空 imageUrl
        // entityId 是 LLM 从上下文中回传的 ProjectAsset.id，用于精确定位
        character: { name: action.name, prompt: action.prompt || '', description: action.description, imageUrl: '', entityId: action.entityId } as any,
      });
    } else if (action.actionType === 'delete') {
      const name = action.name || action.entityId;
      if (name) {
        await onApply({ type: 'delete', character: { name, prompt: '', entityId: action.entityId } as any });
      }
    }
  };

  return (
    <EntityChatPanel
      projectId={projectId}
      episodeScriptId={episodeScriptId}
      contextType={ChatContextType.SCRIPT_CHARACTERS}
      entityName={t('characters.name')}
      currentData={currentData ? { items: currentData.characters } : null}
      onApplyAction={handleApplyAction}
    />
  );
}
